module.exports = __webpack_public_path__ + "rosacea_2_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_2_before.jpg
// module id = 980
// module chunks = 0